import _ from 'lodash'
import {ALPHABET} from '../../common/constants'
import htmlEditButton from "quill-html-edit-button"

export default {
  props: ['source', 'pageId'],
  data() {
    return {
      content: _.cloneDeep(this.source) || {},
      alphabet: ALPHABET,
      editorModules: {
        name: 'htmlEditButton',
        module: htmlEditButton,
        options: {
          msg: 'Edit HTML',
          buttonHTML: '<svg viewBox="0 0 18 18"> <polyline class="ql-even ql-stroke" points="5 7 3 9 5 11"></polyline> <polyline class="ql-even ql-stroke" points="13 7 15 9 13 11"></polyline> <line class="ql-stroke" x1="10" x2="8" y1="5" y2="13"></line> </svg>'
        }
      }
    }
  },
  computed: {
    //
  },
  watch: {
    //
  },
  methods: {
    getValue() {
      return this.content
    },
    setContent() {

    },
    setup() {
      $('[data-lfm="file"]').filemanager('file', {prefix: '/filemanager'});
      $('[data-lfm="image"]').filemanager('image', {prefix: '/filemanager'});
    }
  },
  mounted() {
    this.setup()
    this.setContent()
  }
}
